import React, { useContext, useState } from 'react'
import FlexView from 'react-flexview/lib'
import {
    FirebaseService,
    FirebaseConfigKey,
} from '../../../../services/FirebaseService'
import { liabilityLimitPretty } from '../../../../services/utils'
import { isMobile } from 'react-device-detect'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { ReactComponent as LiabilityShield } from '../../../../assets/liability_shield.svg'
import {
    RadioGroup,
    FormControlLabel,
    Radio,
    Dialog,
    Divider,
    Checkbox,
    Grid,
} from '@material-ui/core'
import PolicyLiabilityExtensionContext, {
    PolicyLiabilityExtensionContextStore,
    ACTIONS,
} from '../../../../context/PolicyLiabilityExtensionContext'
import CircledPopUpFrame from '../../../Core/CircledPopUpFrame'
import { ElevatedCircle } from '../../../Core/ElevatedCircle'
import { Action } from '../../../../models/Action'
import { GreenButton } from '../../../Core/Buttons/GreenButton'
import {
    EventEmitterService,
    EventKey,
} from '../../../../services/EventEmitterService'
import { SkywatchDialog } from '../../../PopUps/SkywatchDialog'
import { InsuranceTypes } from '../../../../models/insurance-models/InsuranceBillingPeriodModel'
import { PolicyRenewalContextStore } from '../../../../context/PolicyRenewalContext'
import { SUBSCRIPTION_STATE } from '../../../../models/insurance-models/PolicySubscriptionState'
import { SessionContextStore } from '../../../../context/SessionContext'
import { SkyPaper } from '../../../Core/Frames/SkyPaper'
import { lazyWithPreload } from '../../../../utilities/RLazyLoading'
import { CustomizeCoverages } from '../../../Insurance/Coverages/CustomizeCoverages'
import { BuyingInsuranceContextStore } from '../../../../context/BuyingInsuranceContext'
import {
    SectionSelect,
    SectionSlider,
    SectionSpecialSelect,
    SectionTria,
} from '../../../Core/Form/FormComponents'
import { ModifyPolicyOld } from '../ModifyPolicyOld'
import { PolicyManagementContextStore } from '../../../../context/PolicyManagementContext'
import { ModificationContextStore } from '../../../../context/ModificationContext'
const CustomizeLiabilitySection = lazyWithPreload(() =>
    import(
        '../../../Insurance/CustomizePolicySections/CustomizeLiabilitySection'
    ).then((module) => ({ default: module.CustomizeLiabilitySection }))
)

var classNames = require('classnames')

interface LiabilitySectionProps {
    insurance: ActiveInsuranceModel;
}

export const LiabilityExtensionManage = ({
    insurance,modificationObject
}: LiabilitySectionProps) => {
    
    const liabilityExtensionContext = useContext(
        PolicyLiabilityExtensionContextStore
    )
    const policyRenewalContext = useContext(PolicyRenewalContextStore)
    const sessionContext = React.useContext(SessionContextStore)
    const myPoliciesContext = useContext(PolicyManagementContextStore)
    const offersContext = React.useContext(BuyingInsuranceContextStore)

    const [selectedOffer, setSelectedOffer] = React.useState(
        policyRenewalContext.insuranceSubscriptionState ==
            SUBSCRIPTION_STATE.CURRENT
            ? {
                  liabilityLimit: insurance.liabilityLimit,
                  finalCost: 0,
              }
            : liabilityExtensionContext.offers.find(
                  (l) =>
                      l.liabilityLimit == insurance.subscription.liabilityLimit
              )
    )

    const [additionalCost, setAdditionalCost] = React.useState(0)

    const chooseOffer = (offer) => {
        setSelectedOffer(offer)
        if (
            policyRenewalContext.insuranceSubscriptionState ==
            SUBSCRIPTION_STATE.CURRENT
        )
            setAdditionalCost(offer.finalCost)
        else
            setAdditionalCost(
                offer.finalCost -
                    liabilityExtensionContext.offers.find(
                        (l) =>
                            l.liabilityLimit ==
                            insurance.subscription.liabilityLimit
                    ).finalCost
            )
    }

    const onLiabilityChange = (e) => {
        let offer = liabilityExtensionContext.offers.find(
            (l) => l.liabilityLimit == e.target.value
        )
        if (offer) {
            if (offer.commercial && !sessionContext.user.commercial) {
                EventEmitterService.dispatch(
                    EventKey.SHOW_COMMERCIAL_POPUP,
                    offer.liabilityLimit
                )
                EventEmitterService.once(
                    EventKey.USER_ACCEPT_COMMERCIAL,
                    () => {
                        chooseOffer(offer)
                    }
                )
            } else {
                chooseOffer(offer)
            }
        } else if (
            policyRenewalContext.insuranceSubscriptionState ==
            SUBSCRIPTION_STATE.CURRENT
        ) {
            setSelectedOffer({
                liabilityLimit: insurance.liabilityLimit,
                finalCost: 0,
            })
            setAdditionalCost(0)
        }
    }

    const applyLiabilityExtension = () => {
        if (selectedOffer.finalCost == 0) return

        liabilityExtensionContext.purchaseLiabilityExtension(selectedOffer)
    }
    return (
        <>
            <ModifyPolicyOld insurance={insurance} modificationObject={modificationObject} />
            {/* <div className="text-body black">{policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT ? 'Increase' : 'Update'} Liability</div>
            <div className="text-small gray margin-top-basic">The maximum amount of money paid for bodily injury/property damage in the event of a claim</div>
            <RadioGroup className="margin-top-basic" 
                value={selectedOffer.liabilityLimit} 
                onChange={onLiabilityChange}>
                <FlexView className="space-evenly">
                    {policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT && 
                        <FormControlLabel 
                            value={insurance.liabilityLimit} 
                            control={<Radio  color="primary" />}
                            label={<div className="text-small blue bold">{selectedOffer.liabilityLimit}</div>} /> }
                    {liabilityExtensionContext.offers.map(option => 
                        <FormControlLabel 
                            key={option.liabilityLimit} 
                            value={option.liabilityLimit} 
                            control={<Radio  color="primary" />}
                            label={<div 
                                className={classNames("text-small", 
                                    {"blue bold": insurance.subscription.liabilityLimit == option.liabilityLimit &&
                                                    policyRenewalContext.insuranceSubscriptionState != SUBSCRIPTION_STATE.CURRENT})}>
                                    {liabilityLimitPretty(option.liabilityLimit)}
                                </div>} />
                        )}
                </FlexView>
            </RadioGroup> */}
            {/*             <FlexView column={isMobile} vAlignContent={'center'} className="space-between margin-bottom-basic">
                {policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT ? 
                    <div className="text-small black">This change will be effective immediately</div>
                : 
                    <div className="text-small black">This change will be effective on your next billing date</div>}
            </FlexView>
            <FlexView column hAlignContent={'center'}>
                {additionalCost > 0 && (
                    policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT ?
                        <div className="text-small bold blue margin-top-basic margin-bottom-basic">You will be charged an additional {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{additionalCost.toLocaleStringToFixed()}</div> 
                    :
                        <div className="text-small bold blue margin-top-basic margin-bottom-basic">Your policy renewal cost will be an additional {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{additionalCost.toLocaleStringToFixed()}</div> 
                )}
                <div className="margin-bottom-small"><GreenButton disabled={additionalCost == 0} onClick={applyLiabilityExtension}>Update Liability</GreenButton></div>
            </FlexView> */}
        </>
    )
}

export const LiabilitySection = ({ insurance , isRenewal}: LiabilitySectionProps) => {
    const [open, setOpen] = useState(false)
    const policyRenewalContext = useContext(PolicyRenewalContextStore)
    const sessionContext = React.useContext(SessionContextStore)
    const modificationContext = React.useContext(ModificationContextStore)


    const openDialog = () => {
        setOpen(true)
    }

    const closeDialog = () => {
        setOpen(false)
    }

    const getRenewalOffer = () =>
        policyRenewalContext.renewalOffers.find(
            (l) => l.liabilityLimit == insurance.subscription.liabilityLimit
        )

    const getRenewalLiabilityPremium = () => {
        const offer = getRenewalOffer()
        if (offer)
            return offer.liabilityLimitPremium + offer.liabilityLimitDiscount
        else return 0
    }

    React.useEffect(() => {
        let id = EventEmitterService.subscribe(
            EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS,
            closeDialog
        )

        return function cleanup() {
            EventEmitterService.unsubscribe(
                EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS,
                id
            )
        }
    }, [])

    return (
        <>
            <Grid item xs={12}>
                <SkyPaper>
                    <FlexView className="space-between">
                        <div className="text-body bold black">
                            Aircraft Damage Liability
                        </div>
                        {/* {insurance.isActiveOrSchedule() &&
                     FirebaseService.getBoolean(FirebaseConfigKey.LIABILTY_LIMIT_EXTENSION_AVAILABLE) &&
                     insurance.insuranceType != InsuranceTypes.HOURLY &&
                      <div onClick={openDialog} className="text-small blue underline bold clickable">Modify</div>} */}
                    </FlexView>
                    <FlexView
                        column={isMobile}
                        className={classNames(
                            { 'space-between': !isMobile },
                            'margin-top-small'
                        )}
                    >
                        {/* <div className="black text-small">
                    {liabilityLimitPretty(policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT 
                        ? insurance.liabilityLimit : insurance.subscription.liabilityLimit)} Liability limit
                </div> */}
                        <div className="black text-small">
                            {' '}
                            {
                                isRenewal ? modificationContext.subscription.offer[
                                    'liability'
                                ].liability : insurance.policyCoverages[
                                    'aircraftDamageLiability'
                                ].liability
                            }{' '}
                            Liability limit
                        </div>
                        <div className="gray margin-top-small text-tiny">
                            Premium:{' '}
                            {FirebaseService.getValue(
                                FirebaseConfigKey.CURRENCY_SYMBOL
                            )}
                            {
                                isRenewal ? modificationContext.subscription.offer[
                                    'liability'
                                ].price :
                                insurance.policyCoverages[
                                    'aircraftDamageLiability'
                                ].price
                            }
                            {/* {policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT ? 
                        insurance.totalLiabilityPremium.toLocaleStringToFixed() : getRenewalLiabilityPremium().toLocaleStringToFixed()} */}
                        </div>
                    </FlexView>
                </SkyPaper>
            </Grid>
            <Grid item xs={12}>
                <SkyPaper>
                    <FlexView className="space-between">
                        <div className="text-body bold black">
                            Bodily Injury Liability
                        </div>
                        {/* {insurance.isActiveOrSchedule() &&
                     FirebaseService.getBoolean(FirebaseConfigKey.LIABILTY_LIMIT_EXTENSION_AVAILABLE) &&
                     insurance.insuranceType != InsuranceTypes.HOURLY &&
                      <div onClick={openDialog} className="text-small blue underline bold clickable">Modify</div>} */}
                    </FlexView>
                    <FlexView
                        column={isMobile}
                        className={classNames(
                            { 'space-between': !isMobile },
                            'margin-top-small'
                        )}
                    >
                        <div className="black text-small">
                            {' '}
                            {
                                isRenewal ? modificationContext.subscription.offer[
                                    'bodilyInjury'
                                ].liability : insurance.policyCoverages[
                                    'bodilyInjuryLiability'
                                ].liability
                            }{' '}
                            Liability limit
                        </div>

                        <div className="gray margin-top-small text-tiny">
                            Premium:{' '}
                            {FirebaseService.getValue(
                                FirebaseConfigKey.CURRENCY_SYMBOL
                            )}
                            {
                                isRenewal ? modificationContext.subscription.offer[
                                    'bodilyInjury'
                                ].price : insurance.policyCoverages[
                                    'bodilyInjuryLiability'
                                ].price
                            }
                            {/* {policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT ? 
                        insurance.totalLiabilityPremium.toLocaleStringToFixed() : getRenewalLiabilityPremium().toLocaleStringToFixed()} */}
                        </div>
                    </FlexView>
                </SkyPaper>
            </Grid>
            {insurance.policyCoverages['deductibleReimbursement'] && 
            <Grid item xs={12}>
                <SkyPaper>
                    <FlexView className="space-between">
                        <div className="text-body bold black">
                            Deductible Reimbursement
                        </div>
                        {/* {insurance.isActiveOrSchedule() &&
                     FirebaseService.getBoolean(FirebaseConfigKey.LIABILTY_LIMIT_EXTENSION_AVAILABLE) &&
                     insurance.insuranceType != InsuranceTypes.HOURLY &&
                      <div onClick={openDialog} className="text-small blue underline bold clickable">Modify</div>} */}
                    </FlexView>
                    <FlexView
                        column={isMobile}
                        className={classNames(
                            { 'space-between': !isMobile },
                            'margin-top-small'
                        )}
                    >
                        <div className="black text-small">
                            {' '}
                            {
                                isRenewal ? modificationContext.subscription.offer[
                                    'deductibleReimbursement'
                                ].liability:
                                insurance.policyCoverages[
                                    'deductibleReimbursement'
                                ]?.liability ?? "$5,000"
                            }{' '}
                            Liability limit
                        </div>
                        <div className="gray margin-top-small text-tiny">
                            Premium:{' '}
                            {FirebaseService.getValue(
                                FirebaseConfigKey.CURRENCY_SYMBOL
                            )}
                            {
                                isRenewal ? modificationContext.subscription.offer[
                                    'deductibleReimbursement'
                                ].price : insurance.policyCoverages[
                                    'deductibleReimbursement'
                                ].price
                            }
                            {/* {policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT ? 
                        insurance.totalLiabilityPremium.toLocaleStringToFixed() : getRenewalLiabilityPremium().toLocaleStringToFixed()} */}
                        </div>
                    </FlexView>
                </SkyPaper>
            </Grid>
            }
            <PolicyLiabilityExtensionContext>
                <SkywatchDialog
                    open={open}
                    closeDialog={closeDialog}
                    circleHeader={
                        <ElevatedCircle>
                            {' '}
                            <LiabilityShield className="medium-icon" />
                        </ElevatedCircle>
                    }
                    closeTitle="Liability Coverage"
                    maxWidth={'sm'}
                >
                    <LiabilityExtensionManage insurance={insurance} />
                </SkywatchDialog>
            </PolicyLiabilityExtensionContext>
        </>
    )
}
